import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-45f02040")

_pushScopeId("data-v-45f02040")
const _hoisted_1 = { class: "stats__body" }
const _hoisted_2 = { class: "stats__group" }
const _hoisted_3 = { class: "stat__item" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "stat__name" }, "Points", -1)
const _hoisted_5 = { class: "stat__info" }
const _hoisted_6 = { class: "stat__leader" }
const _hoisted_7 = { class: "stat__text" }
const _hoisted_8 = { class: "stat__text--primary" }
const _hoisted_9 = { class: "stat__text--secondary" }
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "stat__abbr" }, "PTS", -1)
const _hoisted_11 = { class: "stat__rank" }
const _hoisted_12 = /*#__PURE__*/_createVNode("sup", null, "ième", -1)
const _hoisted_13 = { class: "stat__item" }
const _hoisted_14 = /*#__PURE__*/_createVNode("div", { class: "stat__name" }, "Victoires", -1)
const _hoisted_15 = { class: "stat__info" }
const _hoisted_16 = { class: "stat__leader" }
const _hoisted_17 = { class: "stat__text" }
const _hoisted_18 = { class: "stat__text--primary" }
const _hoisted_19 = /*#__PURE__*/_createVNode("div", { class: "stat__text--secondary" }, [
  /*#__PURE__*/_createVNode("div", { class: "stat__abbr" }, "W")
], -1)
const _hoisted_20 = { class: "stat__item" }
const _hoisted_21 = /*#__PURE__*/_createVNode("div", { class: "stat__name" }, "Défaites", -1)
const _hoisted_22 = { class: "stat__info" }
const _hoisted_23 = { class: "stat__leader" }
const _hoisted_24 = { class: "stat__text" }
const _hoisted_25 = { class: "stat__text--primary" }
const _hoisted_26 = /*#__PURE__*/_createVNode("div", { class: "stat__text--secondary" }, [
  /*#__PURE__*/_createVNode("div", { class: "stat__abbr" }, "D")
], -1)
const _hoisted_27 = { class: "stat__item" }
const _hoisted_28 = /*#__PURE__*/_createVNode("div", { class: "stat__name" }, "Nulles", -1)
const _hoisted_29 = { class: "stat__info" }
const _hoisted_30 = { class: "stat__leader" }
const _hoisted_31 = { class: "stat__text" }
const _hoisted_32 = { class: "stat__text--primary" }
const _hoisted_33 = /*#__PURE__*/_createVNode("div", { class: "stat__text--secondary" }, [
  /*#__PURE__*/_createVNode("div", { class: "stat__abbr" }, "N")
], -1)
const _hoisted_34 = { class: "stat__item" }
const _hoisted_35 = /*#__PURE__*/_createVNode("div", { class: "stat__name" }, "Points Marqués", -1)
const _hoisted_36 = { class: "stat__info" }
const _hoisted_37 = { class: "stat__leader" }
const _hoisted_38 = { class: "stat__text" }
const _hoisted_39 = { class: "stat__text--primary" }
const _hoisted_40 = /*#__PURE__*/_createVNode("div", { class: "stat__text--secondary" }, [
  /*#__PURE__*/_createVNode("div", { class: "stat__abbr" }, "PP")
], -1)
const _hoisted_41 = { class: "stat__item" }
const _hoisted_42 = /*#__PURE__*/_createVNode("div", { class: "stat__name" }, "Points Accordés", -1)
const _hoisted_43 = { class: "stat__info" }
const _hoisted_44 = { class: "stat__leader" }
const _hoisted_45 = { class: "stat__text" }
const _hoisted_46 = { class: "stat__text--primary" }
const _hoisted_47 = /*#__PURE__*/_createVNode("div", { class: "stat__text--secondary" }, [
  /*#__PURE__*/_createVNode("div", { class: "stat__abbr" }, "PC")
], -1)
const _hoisted_48 = {
  key: 0,
  class: "stats__title"
}
const _hoisted_49 = /*#__PURE__*/_createVNode("i", { class: "icon-attention-circled" }, null, -1)
const _hoisted_50 = /*#__PURE__*/_createTextVNode("Classement Provisoire ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode("div", _hoisted_5, [
          _createVNode("div", _hoisted_6, [
            _createVNode("div", _hoisted_7, [
              _createVNode("div", _hoisted_8, _toDisplayString(_ctx.points), 1),
              _createVNode("div", _hoisted_9, [
                _hoisted_10,
                _createVNode("div", _hoisted_11, [
                  _createTextVNode(_toDisplayString(_ctx.teamRank), 1),
                  _hoisted_12
                ])
              ])
            ])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_13, [
        _hoisted_14,
        _createVNode("div", _hoisted_15, [
          _createVNode("div", _hoisted_16, [
            _createVNode("div", _hoisted_17, [
              _createVNode("div", _hoisted_18, _toDisplayString(_ctx.win), 1),
              _hoisted_19
            ])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_20, [
        _hoisted_21,
        _createVNode("div", _hoisted_22, [
          _createVNode("div", _hoisted_23, [
            _createVNode("div", _hoisted_24, [
              _createVNode("div", _hoisted_25, _toDisplayString(_ctx.lost), 1),
              _hoisted_26
            ])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_27, [
        _hoisted_28,
        _createVNode("div", _hoisted_29, [
          _createVNode("div", _hoisted_30, [
            _createVNode("div", _hoisted_31, [
              _createVNode("div", _hoisted_32, _toDisplayString(_ctx.nul), 1),
              _hoisted_33
            ])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_34, [
        _hoisted_35,
        _createVNode("div", _hoisted_36, [
          _createVNode("div", _hoisted_37, [
            _createVNode("div", _hoisted_38, [
              _createVNode("div", _hoisted_39, _toDisplayString(_ctx.pf), 1),
              _hoisted_40
            ])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_41, [
        _hoisted_42,
        _createVNode("div", _hoisted_43, [
          _createVNode("div", _hoisted_44, [
            _createVNode("div", _hoisted_45, [
              _createVNode("div", _hoisted_46, _toDisplayString(_ctx.pa), 1),
              _hoisted_47
            ])
          ])
        ])
      ])
    ]),
    (_ctx.awaitingApproval)
      ? (_openBlock(), _createBlock("span", _hoisted_48, [
          _hoisted_49,
          _hoisted_50
        ]))
      : _createCommentVNode("", true)
  ]))
})